import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad2CBlue3ABlue = () => <CrossRoad coords="1119.000000, 664.000000"/>;
export default CrossRoad2CBlue3ABlue;
